module.exports = __webpack_public_path__ + "media/images/emblems/Stabio-coat_of_arms-37d0c14c548d72afc3ed4ecb8b86cc7a.svg";